import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { ViewMode } from '../../types';
import ViewListIcon from '@material-ui/icons/ViewList';
import ViewGridIcon from '@material-ui/icons/GridOn';
import { makeStyles } from '@material-ui/core';

type Props = {
  viewMode: ViewMode;
  setViewMode: (viewMode: ViewMode) => void;
};

export const ViewToggle = ({ viewMode, setViewMode }: Props) => {
  const styles = useStyles();

  const _handleChangeView = (
    _: React.MouseEvent<HTMLElement>,
    newViewMode: ViewMode | null,
  ) => {
    if (newViewMode) {
      setViewMode(newViewMode);
    }
  };

  return (
    <ToggleButtonGroup
      value={viewMode}
      size="small"
      exclusive
      onChange={_handleChangeView}
      aria-label="view mode"
      className={styles.container}
    >
      <ToggleButton value={ViewMode.GRID} aria-label="grid view">
        <ViewGridIcon />
      </ToggleButton>
      <ToggleButton value={ViewMode.LIST} aria-label="list view">
        <ViewListIcon />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

const useStyles = makeStyles(theme => ({
  container: {
    background: theme.palette.background.paper,
  },
}));
